(function (app) {
  $(document).ready(function () {

    app.Referral = function (config) {

      var _this = this;
      var nameSpace = 'ReferralProgram',
        context = '.page__referral-program--container';

      _this.validatePassword = function () {
        var passwordInformationForm = $('form[name="user__edit"]');

        var fields = {
          'password': $('input[name="password"]', passwordInformationForm),
          'confirm_password': $('input[name="confirm_password"]', passwordInformationForm),
        };

        var values = {
          password: $.trim(fields.password.val()),
          confirm_password: $.trim(fields.confirm_password.val())
        };

        var errors = [];

        $.each(fields, function () {
          $(this).closest('.form-group').removeClass('has-error');
        });

        if (values.password != values.confirm_password) {
          fields.confirm_password.closest('.form-group').addClass('has-error');
          errors.push('Passwords do not match');
        }

        if (_.size(errors)) {
          alertify.error(errors.join('<br>'));
          return false;
        }
        return true;
      };

      _this.resizeCanvas = function (canvas) {
        // When zoomed out to less than 100%, for some very strange reason,
        // some browsers report devicePixelRatio as less than 1
        // and only part of the canvas is cleared then.
        var ratio = Math.max(window.devicePixelRatio || 1, 1);

        // This part causes the canvas to be cleared
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);

        // This library does not listen for canvas changes, so after the canvas is automatically
        // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
        // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
        // that the state of this library is consistent with visual state of the canvas, you
        // have to clear it manually.
        _this.signaturePad.clear();
      };

      _this.getRequestData = function () {
        var requestData = {};
        $('form', $(context)).each(function () {
          var formData = $(this).serializeObject();
          requestData = $.extend({}, requestData, formData);
        });

        return requestData;
      };

      _this.validateUniqueUser = function () {
        var query = $.Deferred();
        var requestData = _this.getRequestData();
        $('.form-group').removeClass('has-error');
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              return query.resolve(response);
            }
          })
          .setEvent('onError', function (error) {
            if (typeof error.message != 'undefined') {
              var errorMessage = error.message;
              delete errorMessage.error;
              var errorText;
              _.each(errorMessage, function (value, key) {
                $(':input[name="' + key + '"]').closest('.form-group').addClass('has-error');
                errorText = value;
              });
              app.flashMessenger('error', errorText);
            }
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
          .setRequestData({
            'email': requestData.email,
            'emailName': requestData.emailName,
            'subdomain': requestData.subdomain
          }, false)
        ;

        appTransport.post(config.mdcApp + '/api/public/user/unique');
        return query.promise();
      };

      _this.save = function () {
        var query = $.Deferred();

        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              if (response.success == true) {
                $('.page__body', $(context)).hide();
                $('.request-success-message', $(context)).show();
                $('.request-get-message', $(context)).hide();
                $('.menu__referral-program').attr('href', config.mdcApp);
                return query.resolve(response);
              } else {
                app.flashMessenger('error', response);
                return query.reject(response);
              }
            }
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          });

        var requestData = _this.getRequestData();

        appTransport.post('/api/user/brand-partner', requestData);
        return query.promise();
      };

      return {
        init: function () {
          var $canvas = $('canvas', $(context))[0];

          var forms = document.getElementsByClassName('needs-validation');
          // Loop over them and prevent submission
          var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
              if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
              } else {
                event.preventDefault();
                var $button = $(form).find('button[type=submit]');
                $.when(_this.validateUniqueUser()).done(function () {
                  $button.button('reset');
                  if (_this.signaturePad.isEmpty()) {
                    $('.signature-pad', $(context)).addClass('is-invalid');
                  } else {
                    $('.signature-pad', $(context)).removeClass('is-invalid');
                    $button.button('loading');
                    $.when(_this.save()).done(function () {
                      $button.button('reset');
                    }).fail(function () {
                      $button.button('reset');
                    });
                  }

                }).fail(function () {
                  $button.button('reset');
                });
              }
              form.classList.add('was-validated');

            }, false);
          });

          $(document).off('click.signature-pad').on('click.signature-pad', context + ' .signature-pad', function (e) {
            $(this).removeClass('is-invalid');
          }).off('click.agree').on('click.agree', context + ' :input[name="agree[]"]', function (e) {
            if ($(this).is(':checked')) {
              $('.signature--container', $(context)).show();
              _this.resizeCanvas($canvas);
            } else {
              $('.signature--container', $(context)).hide();
            }
          }).off('keyup.emailName').on('keyup.emailName', context + ' :input[name=emailName]', function (e) {
            var value = $(this).val();
            if (value.indexOf('@') >= 0) {
              value = value.replace(/@/gi, '');
            }
            $(this).val(value);
          }).off('keyup.subdomain').on('keyup.subdomain', context + ' :input[name=subdomain]', function (e) {
            var value = $(this).val();
            if (value.indexOf('www.') >= 0) {
              value = value.replace(/www./gi, '');
            }
            $(this).val(value);
          });

          _this.signaturePad = new SignaturePad($canvas, {
            // It's Necessary to use an opaque color when saving image as JPEG;
            // this option can be omitted if only saving as PNG or SVG
            backgroundColor: 'rgb(255, 255, 255)'
          });
          window.onresize = _this.resizeCanvas($canvas);

          var $password = $(':input[name=password]', $(context))[0];
          var $confirmPassword = $(':input[name=confirm_password]', $(context))[0];

          _this.validatePassword = function () {
            if ($password.value != $confirmPassword.value) {
              $confirmPassword.setCustomValidity("Passwords Don't Match");
            } else {
              $confirmPassword.setCustomValidity('');
            }
          };

          $password.onchange = _this.validatePassword;
          $confirmPassword.onkeyup = _this.validatePassword;

        }
      }

    }

  });

})(PreBuilt);

